import React from "react";
import { Col, Row } from "react-bootstrap";
import { SliderPage } from ".";
import { useProduct } from "../adapters/uplist";
import {
  AERIAL_PHOTO_SAMPLES,
  AERIAL_VIDEO_SAMPLES,
} from "../assets/images/samples";
import { InternalSection } from "../components";
import { BlockCheckbox, InlineCheckbox, Select } from "../components/fields";
import { Notes } from "../components/fields/Notes";
import AddOnSection from "../components/order/AddOnSection";
import { TWILIGHT_VIDEO_SKUS, VIDEO_APPT_SKUS } from "../helpers/constants";
import { useProductDiscount } from "../hooks";
import {
  TWILIGHT_AERIAL_PHOTO_SAMPLES,
  TWILIGHT_AERIAL_VIDEO_SAMPLES,
} from "../assets/images/samples/twilight";

const AerialPage = () => {
  const { data: addlPhotoProduct } = useProduct("4100");
  const addlPhotoValue = (value, price) => {
    const label = `${value * 5} Additional Photos +$${price * value}`;
    return { value, label };
  };

  const addlPhotosOptions = () => {
    return [...Array(4)].map((_, value) => {
      value++;
      return addlPhotoValue(value, addlPhotoProduct?.price);
    });
  };
  const premium_discount = useProductDiscount({
    other_product_skus: VIDEO_APPT_SKUS,
    product_sku: "4001",
    discount_sku: "4002",
  });
  const classic_discount = useProductDiscount({
    other_product_skus: ["4007", ...VIDEO_APPT_SKUS],
    product_sku: "4008",
    discount_sku: "4002",
  });

  const twilight_photo_discount = useProductDiscount({
    other_product_skus: ["1004"],
    product_sku: "4009",
    discount_sku: "4101",
  });
  const twilight_video_discount = useProductDiscount({
    other_product_skus: ["4009", ...TWILIGHT_VIDEO_SKUS],
    product_sku: "4010",
    discount_sku: "4101",
  });

  return (
    <SliderPage title="Aerial">
      <Row>
        <BlockCheckbox sku="4007" modal={{ urls: AERIAL_PHOTO_SAMPLES }} />
        <BlockCheckbox
          sku="4008"
          modal={{ urls: AERIAL_VIDEO_SAMPLES, vimeo: true }}
          discount={classic_discount}
        />
        <BlockCheckbox
          sku="4001"
          modal={{ urls: AERIAL_VIDEO_SAMPLES, vimeo: true }}
          discount={premium_discount}
        />
        <BlockCheckbox
          sku="4009"
          modal={{ urls: TWILIGHT_AERIAL_PHOTO_SAMPLES }}
          discount={twilight_photo_discount}
        />
        <BlockCheckbox
          sku="4010"
          modal={{ urls: TWILIGHT_AERIAL_VIDEO_SAMPLES, vimeo: true }}
          discount={twilight_video_discount}
        />
      </Row>
      <AddOnSection
        title="Aerial Add-Ons"
        show_skus={["4006", "4007", "4001"]}
        addon_skus={["4100", "6100", "6101"]}
      >
        <AddOnSection show_skus={["4007", "4001"]} addon_skus={["4001"]}>
          <Row className="mb-3">
            <Col sm={6} xl={4}>
              <Select sku="4100" options={addlPhotosOptions()} />
            </Col>
          </Row>
        </AddOnSection>
        <InlineCheckbox sku="6100" />
        <InlineCheckbox sku="6101" />
        <InlineCheckbox sku="9814" />
      </AddOnSection>
      <InternalSection>
        <InlineCheckbox sku="4301" />
        <Notes name="notes.aerial" label="Aerial Appt Notes" />
      </InternalSection>
    </SliderPage>
  );
};

export default AerialPage;
